<template>
  <div>
    <div class="flights-box">
      <div class="flights-head df">
        <div class="flights-nub">航司/航班信息</div>
        <div class="flights-type">机型</div>
        <div class="df">
          <div class="flights-star sort-conent" style="justify-content:flex-end;">
            <span @click="flightTimeSort('start'),setSortActive(0)">起飞时间/起飞机场</span>
            <sort-box :btnActive="flightSartSort" :styleColor="sortShow[0]"></sort-box>
          </div>
          <div class="arrows"></div>
          <div class="flights-end sort-conent">
            <span @click="flightTimeSort('end'),setSortActive(1)">到达时间/到达机场</span>
            <sort-box :btnActive="flightEndSort" :styleColor="sortShow[1]"></sort-box>
          </div>
        </div>
        
        <div class="settlement settlementBtn">
          <span @click="setSettlementPrice(),setSortActive(2)">最低结算价</span>
          <sort-box :btnActive="settlementPrice" :styleColor="sortShow[2]"></sort-box>
        </div>
        <div class="tax">
          <el-checkbox v-model="checkedTax">含税</el-checkbox>
        </div>
      </div>
      <div v-loading="loading">
        <div v-if="flightsList.length === 0" class="flightsListN">暂无数据</div>
        <div class="flights-content" v-for="(item,index) in flightsList" :key="index">

          <div class="flights-contentT df">
            <div class="flights-nub df">

              <img-logo class="flight-logo" :logoImg="item.airCompanyLogoImg"></img-logo>
              <b>{{item.airCompanyName}}</b>
              <span>{{item.flightNo}}</span>
              <el-popover
                      v-if="item.hasShare"
                      placement="top-start"
                      :visible-arrow="false"
                      width="200"
                      offset="0"
                      trigger="hover"
                      popper-class="flight-popper"
                      :content="`实际乘坐航班：${item.sharedAirCompanyName}${item.sharedFlightNo}请按实际乘坐航班办理值机。`">
                <!--<el-button slot="reference" type="text">共享</el-button>-->
                <el-link class="share-link" slot="reference" type="primary">共享</el-link>
              </el-popover>
            </div>
            <div class="flights-type">{{item.planeType}}</div>
            <div class="flights-data df">
              <div class="flights-star">
                <h5>{{item.depTime}}</h5>
                <span>
                  {{item.depAirportName}} {{item.depTerminal}}
                  
                </span>
              </div>
              <div class="arrows">
                <span class="arrows_times">
                  <span
                    v-if="item.stopNum"
                    @mousemove="arrowsShow = index + 1"
                    @mouseout="arrowsShow = null"
                    style="color:#237dc9"
                  >经停</span>
                  <span v-else>直达</span>
                  {{item.duration.replace(/h/g,"小时").replace(/m/g,"分")}}
                </span>
                <transition name="upBox">
                  <air-stop
                    :flightNo="item.flightNo"
                    :stopNum="item.stopNum>0?Math.random()*index + 1:0"
                    v-show="arrowsShow===index + 1"
                  />
                </transition>
                
              </div>
              <div class="flights-end">
                <h5>{{item.arrTime}}</h5>
                <span>{{item.arrAirportName}} {{item.arrTerminal}}</span>
              </div>
            </div>
            <div class="settlement textPrice">
              <span>
                <sup>￥</sup>
                {{!checkedTax?getPrice(item.rebatePrice)
                :getPrice(item.settlementPriceTaxes)}}
              </span>
              <span>起</span>
              <span>({{!checkedTax?'不含税':'含税'}})</span>
            </div>
            <div class="tax">
              <span
                @click="flightsShow[index]?$set(flightsShow,index,false):$set(flightsShow,index,true)"
                :class="{'tax_up':flightsShow[index]}"
              >
                {{flightsShow[index]?'收起':'订票'}}
                <i
                  class="el-icon-caret-bottom"
                  :class="{'tax_icon':flightsShow[index]}"
                ></i>
              </span>
            </div>
            
          </div>
          
          <flight-item
            v-show="flightsShow[index]"
            v-bind="$attrs"
            v-on="$listeners"
            :policys="item.policys"
            :flightsShow="flightsShow[index]"
            :loading="loading"
            :journeyType="(items)=>journeyType(item,items)"
            :ruleText="ruleText"
            :backRule="(val)=>backRule(item,val)"
          ></flight-item>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AirStop from "./airStop";
import SortBox from "./sortBox";
import FlightItem from "./inlandFlightItem";
import ImgLogo from "./airImgLogo";
import { turquoise } from "color-name";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      arrowsShow: null,
      flightsShow: [],
      checkedTax: false,
      flightsIndex: null,
      settlementPrice: true,
      sortShow: [true, false, false],
      imageUrl: `https://lyn.oss-cn-shenzhen.aliyuncs.com/temp/airline-blank-map.jpg`
    };
  },
  components: { AirStop, SortBox, FlightItem, ImgLogo },
  props: {
    flightTimeSort: {
      type: Function,
      default: function() {}
    },
    journeyType: {
      type: Function,
      default: function() {}
    },
    backRule: {
      type: Function,
      default: function() {}
    },
    flightsList: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    },

    flightSartSort: {
      type: Boolean,
      default: false
    },
    flightEndSort: {
      type: Boolean,
      default: false
    },
    ruleText: {
      type: Array,
      default: []
    }
  },
  watch: {
    loading(val) {
      this.flightsShow.length = 0;
    },
    flightsList(val) {
      val.map((item, index) => {
        this.flightsShow[index] = false;
      });
    }
  },
  computed: {},
  methods: {
    setSortActive(index) {
      if (this.flightsList.length === 0) return;
      if (!this.sortShow[index]) {
        this.sortShow.forEach((item, index) => {
          this.$set(this.sortShow, index, false);
        });
        this.sortShow[index] = true;
      }
    },
    getPrice(val) {
      if (val) {
        return val.toFixed(2);
      } else {
        return 0;
      }
    },
    setSettlementPrice() {
      if (this.flightsList.length === 0) return;
      this.settlementPrice = !this.settlementPrice;
      this.flightsList.sort((a, b) => {
        if (this.settlementPrice) {
          return (
            a.policys[0].priceData[0].rebatePrice -
            b.policys[0].priceData[0].rebatePrice
          );
        } else {
          return (
            b.policys[0].priceData[0].rebatePrice -
            a.policys[0].priceData[0].rebatePrice
          );
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./css/flight.less");
.flights-box {
  background: #f5f8fa;
}
.settlement {
  width: 20%;
}
.settlementBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: #237dc9;
  }
}
.textPrice {
  color: #707070;
  span {
    font-size: 12px;
    padding: 0 3px;
    &:first-of-type {
      color: #f60;
      font-size: 28px;
      sup {
        display: inline-block;
        font-size: 12px;
        color: #666666;
        transform: translateX(7px);
      }
    }
  }
}
.tax {
  width: 10%;
  span {
    display: block;
    width: 78px;
    height: 37px;
    background: #f60;
    border-radius: 3px;
    color: white;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    cursor: pointer;
    i {
      margin-left: 5px;
      transition: all 0.5s;
    }
  }
  .tax_up {
    border: 1px solid #f60;
    background: white;
    color: #f60;
  }
  .tax_icon {
    transform: rotate(180deg);
  }
}
.slide-btn-enter-active {
  transition: all 0.3s ease;
}
.slide-btn-leave-active {
  transition: all 0.8s;
}
.slide-btn-enter,
.slide-btn-leave-to {
  transform: rotate(180deg);
  opacity: 0;
}

.fligth-list-enter-active {
  transition: all 0.3s ease;
}
.fligth-list-leave-active {
  transition: all 0.3s ease;
}
.fligth-list-enter,
.fligth-list-leave-to {
  transform: scaleY(1.2);
  opacity: 0;
}
.flights-nub {
  span {
    color: #707070;
  }
  b {
    color: #333;
    letter-spacing: 1px;
  }
}
.flights-type {
  color: #707070 !important;
}
.arrows_times {
  position: absolute;
  width: 200px;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
<style lang="less">
  .flight-popper {
    border-radius: 0;
    border: 1px solid #237DC9;
    padding: 6px;
  }
</style>